module.exports = __webpack_public_path__ + "static/img/Hannah.b21247a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/photos/testimonials/crs/Hannah.png
// module id = egp3
// module chunks = 0